import { useMutation } from '@tanstack/react-query'

import { authServices } from '../authServices'
import { VerifyCodeDTO, CheckCodeSentToPhonePayload } from '../authTypes'

interface UseCheckCodeSentToPhoneOptions {
  onSuccess?: (data: VerifyCodeDTO) => void
  onError?: (error: { errorMessage?: string; code?: string }) => void
}

export const useCheckCodeSentToPhone = (
  options?: UseCheckCodeSentToPhoneOptions,
) => {
  return useMutation<VerifyCodeDTO, Error, CheckCodeSentToPhonePayload>({
    mutationFn: authServices.checkCodeSentToPhone,
    onSuccess: (data) => {
      options?.onSuccess?.(data)
    },
    onError: (error) => {
      options?.onError?.({
        errorMessage: error.message || 'Something went wrong',
        code: 'UNKNOWN_ERROR',
      })
    },
  })
}
